import styled from 'styled-components';
import { makeStyles } from '@mui/styles';

import { COLOR_GRAY_30, COLOR_GRAY_40, COLOR_GRAY_90 } from 'styles/variables/colors';

export const Form = styled.form`
  background: white;
  border: 1px solid ${COLOR_GRAY_30};
  border-radius: 4px;
  padding: 40px;
`;

export const Title = styled.h3`
  margin: 0 0 15px 0;
`;

export const AccountGrid = styled.div`
  display: flex;
  margin-bottom: 60px;
`;

export const Avatar = styled.img`
  height: 124px;
  width: 124px;
  border-radius: 50%;
  margin-right: 40px;
`;

export const AccountInputs = styled.div`
  padding: 15px 0 0 0;
`;

export const ProfileContainer = styled.div`
  padding: 9px 0 0 0;
  width: 300px;
`;

export const EmailLabel = styled.p`
  margin: 0;
  padding: 0 15px;
  font-size: 0.75rem;
  font-weight: bold;
  margin-bottom: 7px;
`;

export const EmailInputGroup = styled.div`
  display: flex;
`;

export const EmailIcon = styled.div`
  color: ${COLOR_GRAY_40};
  padding: 0 10px 0 15px;
`;

export const EmailValue = styled.p`
  margin: 0;
`;

export const useStyles = makeStyles(() => ({
  whatsappNumber: {
    '& .MuiOutlinedInput-root': {
      maxHeight: '48px',
    },

    '& .MuiFormLabel-root': {
      color: COLOR_GRAY_90,
      fontWeight: 'bold',
    },
  },
}));
